import {
  addressSchema,
  contactInfoSchema,
  locationDetailsSchema,
  transportDocumentsSchema,
} from "./validation";
import * as Yup from "yup";

const today = new Date().toISOString().split("T")[0];

export const thirdPartyShippingSchema = Yup.object({
  pickupAddress: Yup.object({
    ...contactInfoSchema.fields,
    ...addressSchema.fields,
    ...locationDetailsSchema.fields,

    startDate: Yup.string()
      .required("Start date is required")
      .test(
        "not-in-past",
        "Start date cannot be in the past",
        (value) => !value || value >= today,
      ),
    endDate: Yup.string()
      .required("End date is required")
      .test(
        "after-start",
        "End date cannot be before start date",
        function (value) {
          const { startDate } = this.parent;
          return !value || !startDate || value >= startDate;
        },
      ),
    timeSlot: Yup.string().required("Time slot is required"),

    pickupNotes: Yup.string().required("Pickup notes are required"),
  }),

  deliveryAddress: Yup.object({
    ...contactInfoSchema.fields,
    ...addressSchema.fields,
    ...locationDetailsSchema.fields,

    startDate: Yup.string()
      .required("Start date is required")
      .test(
        "not-in-past",
        "Start date cannot be in the past",
        (value) => !value || value >= today,
      ),
    endDate: Yup.string()
      .required("End date is required")
      .test(
        "after-start",
        "End date cannot be before start date",
        function (value) {
          const { startDate } = this.parent;
          return !value || !startDate || value >= startDate;
        },
      ),
    timeSlot: Yup.string().required("Time slot is required"),

    deliveryNotes: Yup.string().required("Delivery notes are required"),
  }),

  transportDocuments: Yup.object({
    ...transportDocumentsSchema.fields,
  }).required(),

  billingAddress: Yup.object({
    ...contactInfoSchema.fields,
    ...addressSchema.fields,
    landMark: Yup.string().optional(),
    email: Yup.string().required("Email is required"),
  }),
});
